// extracted by css-extract-rspack-plugin
export default {"app":"app_app__9OAH2"};